import React, {useEffect, useState} from 'react'
import {fetchPlatformList} from "../../../api/platformSetting"


const initialState = {
    isLoading: false,
    isError: false,
    errMsg: '',
    platformList: [{
        clubId: 0,
        order: 0,
        name: '',
        id: 0,
        isEnabled: true,
        createTime: '',
        updateTime: '',
    }],
    sortPlatformList: () => {},
    getPlatformList: () => {}

}

export const PlatformSettingContext = React.createContext(initialState)

export const PlatformSettingProvider = ({children}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errMsg, setErrMsg] = useState('')
    const [platformList, setPlatformList] = useState([])

    const getPlatformList = async () => {
        setIsLoading(true)
        await fetchPlatformList().then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
                return
            }
            setPlatformList(res.data)
        }).catch(err => {
            setIsError(true)
            setErrMsg(err.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const sortPlatformList = (platformList) => {
        setPlatformList(platformList)
    }

    useEffect(() => {
        getPlatformList()
    }, [])

    const value = {
        isLoading,
        isError,
        errMsg,
        platformList,
        sortPlatformList,
        getPlatformList
    }

    return (
        <PlatformSettingContext.Provider value={value}>
            {children}
        </PlatformSettingContext.Provider>
    )
}

export const usePlatformSettingContext = () => {
    const context = React.useContext(PlatformSettingContext)
    if (!context) {
        throw new Error('usePlatformSettingContext must be used within a PlatformSettingProvider')
    }
    return context
}




// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/store/usePlatformSettingContext.js